export function isElementPartiallyInCanvas (element, bbValues) {
  if (!element) return false;
  bbValues = bbValues || getBBValues(element);
  const [bb, bbMain] = bbValues;

  const inBoundsTop = bb.y + bb.height > bbMain.y;
  const inBoundsBottom = bb.y < bbMain.y + bbMain.height;
  const inBoundsLeft = bb.x + bb.width > bbMain.x;
  const inBoundsRight = bb.x < bbMain.x + bbMain.width;

  return inBoundsTop && inBoundsBottom && inBoundsLeft && inBoundsRight;
}

export function isElementInCanvas (element, bbValues) {
  if (!element) return false;
  bbValues = bbValues || getBBValues(element);
  const [bb, bbMain] = bbValues;

  const matrix = new DOMMatrixReadOnly(getComputedStyle(element).transform);
  const { aabox } = svgedit.math.transformBox(bb.x, bb.y, bb.width, bb.height, matrix);

  const inBoundsTop = aabox.y > bbMain.y;
  const inBoundsBottom = aabox.y + aabox.height < bbMain.y + bbMain.height;
  const inBoundsLeft = aabox.x > bbMain.x;
  const inBoundsRight = aabox.x + bb.width < bbMain.x + bbMain.width;

  return inBoundsTop && inBoundsBottom && inBoundsLeft && inBoundsRight;
}

function getBBValues (element) {
  const isImage = INKIVE.DesignFacade.getType(element) === 'image';
  const isIcon = INKIVE.DesignFacade.getType(element) === 'icon';
  const isSticker = INKIVE.DesignFacade.getType(element) === 'sticker';

  const elementImage = isIcon || isSticker
    ? element.querySelector('image')
    : element;

  const bbContent = elementImage && elementImage.textContent.split(' ');
  const dataBbContent = elementImage &&
    elementImage.getAttribute('data-box-coordinates') &&
    elementImage.getAttribute('data-box-coordinates').split(' ');
  const hasBbContent = bbContent && bbContent.length === 4;
  const hasDataBbContent = dataBbContent && dataBbContent.length === 4;
  const hasTransform = !!element.getAttribute('transform');

  const bbMain = document.querySelector('#canvasBackground').getBBox();
  const bb = (isImage || isIcon || isSticker) && (hasBbContent || hasDataBbContent)
    ? INKIVE.EditorFacade.canvas.runExtensions('getLayoutBoxCoord', { layoutBox: element })
    : element.getBBox();

  return [bb, bbMain];
}
